import { create } from "zustand";

interface BookingPopupState {
  /** Booking IDs the owner closed manually; the popup stays hidden for these until reopened or the booking's own response window expires. */
  dismissedIds: string[];
  dismiss: (id: string) => void;
  reopen: (id: string) => void;
}

export const useBookingPopupStore = create<BookingPopupState>((set) => ({
  dismissedIds: [],
  dismiss: (id) => set((state) => (state.dismissedIds.includes(id) ? state : { dismissedIds: [...state.dismissedIds, id] })),
  reopen: (id) => set((state) => ({ dismissedIds: state.dismissedIds.filter((item) => item !== id) })),
}));
